<template>
    <div class="team-list ed-fileview" @click="clear">
        <div class="myTeams-header fileview-title">
            <span class="breadCrumb">
                <span>{{ $t("teams") }}</span>
                <div class="create-btn" @click="openModal()" v-if="teams && teams.length > 0">
                    <span>+</span>
                    {{ this.$t("createTeam") }}
                </div>
            </span>
        </div>
        <div class="team-box" :class="!teams || teams.length === 0 ? 'flex-temp-box' : ''">
            <div class="no-team-box" v-if="(!teams || teams.length === 0) && !loadingStatus" v-cloak>
                <img :src="require('@/home/assets/img/team/no-team.svg')" alt="" />
                <div class="no-teams-tip">{{ this.$t("noTeam") }}</div>
                <div class="create-desc">{{ this.$t("createTip") }}</div>
                <div class="create-btn" @click="openModal()">{{ this.$t("createTeam") }}</div>
            </div>
            <div v-else class="teams">
                <div class="fileview-list-header fileview-list-header-teams">
                    <div :class="item.className" v-for="(item, index) in teamColumns" :key="index">
                        <span>{{ item.title }}</span>
                    </div>
                </div>

                <div class="fileview-scroll" @scroll="clear" ref="filesScroll">
                    <div class="files-box-list files-box-list-recent" ref="filesBoxList">
                        <listTeam
                            v-for="(item, index) in teams"
                            :key="index"
                            :index="index"
                            :item="item"
                            @closeContextmenu="contextmenuBoxShow = false"
                            @contextmenuEvent="contextmenuBoxShow = true"
                            @contextmenu="contextmenu"
                        />
                    </div>
                </div>
            </div>
        </div>
        <Modal v-model="createTeamModal" :title="$t('createTeam')" :loading="true" :mask-closable="false" class="createTeamModal" width="360px">
            <div>
                <Input ref="newTeamInput" v-model="newTeamValue" :placeholder="$t('namePlaceholder')" @keydown.native.enter="createTeam" />
            </div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn" @click="createTeam()">{{ $t("create") }}</div>
                <div class="cancel-btn btn" @click="createTeamModal = false">{{ $t("cancel") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>
        <Modal
            v-model="reTeamNameModal"
            :mask-closable="false"
            :title="$t('editSpaceName')"
            class-name="modal-reTaamName vertical-center-modal"
            width="480px"
        >
            <div style="margin-bottom: 16px; color: #222">{{ $t("spaceName") }}</div>
            <div>
                <Input ref="reTeamInput" v-model="editTeamName"></Input>
            </div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn" @click="reTeamName()">{{ $t("save") }}</div>
                <div class="cancel-btn btn" @click="reTeamNameModal = false">{{ $t("cancelText") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>
        <Modal v-model="delTeamModal" :mask-closable="false" :title="$t('deleteSpace')" width="480px" @on-visible-change="deleteVisibleChange">
            <div style="margin-bottom: 16px; color: #222">{{ $t("confirmSpaceName") }}</div>
            <div>
                <Input ref="delTeamInput" v-model="curTeamName" :placeholder="$t('confirmDeletePlaceholder')"></Input>
            </div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn red-btn" @click="deleltTeam()">{{ $t("delete") }}</div>
                <div class="cancel-btn btn" @click="cancelDelete">{{ $t("cancelText") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>
        <Modal v-model="delTeamConfirmModal" :mask-closable="false" :title="$t('tip')" width="360px">
            <div>{{ $t("deleteSpaceTip") }}</div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn red-btn" @click="confirmDeleltTeam()">{{ $t("okText") }}</div>
                <div class="cancel-btn btn" @click="delTeamConfirmModal = false">{{ $t("cancelText") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>

        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="rightmenuList"
            @handleClicks="handleClick($event)"
        />
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    // import listItem from "./listItem.vue";
    import RightMenu from "../RightMenu.vue";
    import listTeam from "./component/listTeam.vue";

    @Component({
        components: {
            RightMenu,
            listTeam,
        },
    })
    export default class list extends Vue {
        @Prop({ default: [] }) teams: Array<object>;
        @Prop({ default: false }) loadingStatus: boolean;

        // teams =  []
        newTeamValue = "";
        createTeamModal = false;
        reTeamNameModal = false;
        editTeamName = "";
        selectItem = {
            id: "",
            name: "",
            role: 0,
        };
        curTeamName = "";
        delTeamModal = false;
        delTeamConfirmModal = false;

        get teamColumns() {
            return [
                {
                    title: this.$t("spaceName"),
                    key: "name",
                    className: "file-name",
                },
                {
                    title: this.$t("owner"),
                    key: "nick_name",
                    className: "file-user",
                },
                {
                    title: this.$t("member"),
                    key: "memberNum",
                    className: "file-member",
                },
                {
                    title: this.$t("updateTime"),
                    key: "updated_at",
                    className: "file-time",
                },
            ];
        }

        get rightmenuList() {
            let list = [
                { key: 0, label: this.$t("rename") },
                {
                    key: 0,
                    label: this.$t("memberManage"),
                    hide: !this.isPC,
                },
                {
                    key: 2,
                    type: "splitLine",
                },
                { key: 3, label: this.$t("deleteSpace") },
            ];

            if (this.selectItem.role <= 2) {
                list = [
                    {
                        key: 0,
                        label: this.$t("memberManage"),
                        hide: !this.isPC,
                    },
                ];
            }
            if (this.selectItem.role === 3) {
                list = [
                    // { key: 0, label: "重命名" },
                    {
                        key: 0,
                        label: this.$t("memberManage"),
                        hide: !this.isPC,
                    },
                ];
            }
            return list;
        }

        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.showReTeamNameModal();
                    },
                ],
                [
                    1,
                    () => {
                        if (this.selectItem.id) {
                            this.$store.commit("toCurTeamId", this.selectItem.id);
                            this.$bus.$emit("showMember", this.selectItem);
                        }
                    },
                ],
                [
                    3,
                    () => {
                        this.showDelTeamMdoal();
                    },
                ],
            ]);
            if (this.selectItem.role <= 2) {
                clickEvents = new Map([
                    [
                        0,
                        () => {
                            if (this.selectItem.id) {
                                this.$store.commit("toCurTeamId", this.selectItem.id);
                                this.$bus.$emit("showMember", this.selectItem);
                            }
                        },
                    ],
                ]);
            }
            if (this.selectItem.role === 3) {
                clickEvents = new Map([
                    // [
                    //     0,
                    //     () => {
                    //         this.showReTeamNameModal();
                    //     },
                    // ],
                    [
                        0,
                        () => {
                            if (this.selectItem.id) {
                                this.$store.commit("toCurTeamId", this.selectItem.id);
                                this.$bus.$emit("showMember", this.selectItem);
                            }
                        },
                    ],
                ]);
            }
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
            this.clear();
        }

        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }

        contextmenu({ e, item }) {
            this.selectItem = item;
            this.top = e.pageY;
            this.left = e.pageX;
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.top -= 76;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.left -= 117;
            }
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        showReTeamNameModal() {
            (<any>this).editTeamName = (<any>this).selectItem.name;
            this.reTeamNameModal = true;
            this.$nextTick(() => {
                (this.$refs["reTeamInput"] as any)?.focus();
            });
        }
        showDelTeamMdoal() {
            this.delTeamModal = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    (this.$refs["delTeamInput"] as any)?.focus();
                }, 100);
            });
        }

        openModal() {
            if (!this.$checkAuth({ type: "team" })) return;
            this.createTeamModal = true;
            this.$nextTick(() => {
                (this.$refs["newTeamInput"] as any)?.focus();
            });
        }
        createTeam() {
            if (!this.$checkAuth({ type: "team" })) return;
            let teamName = this.newTeamValue;
            if (!teamName) {
                // this.createTeamModal = false;
                (<any>this).$edMessage.warning(this.$t("createTeamFailed"));
                return;
            }
            // if(teamName.length < 1) {
            //     // 群名要大于1个字符
            //     this.$edMessage.error(this.$t('teamNameLenError'))
            //     this.createTeamModal = false;
            //     return;
            // }

            if (teamName.length > 100) {
                this.newTeamValue = "";
                this.$edMessage.error(this.$t("spaceNameLimit"));
                return;
            }

            this.$store
                .dispatch("createNewTeam", teamName)
                .then((res) => {
                    this.newTeamValue = "";
                    this.createTeamModal = false;
                    this.sensors.track("createTeamSpace", {
                        Catalogues: "Team",
                    });
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    setTimeout(() => {
                        (<any>document.querySelector(".fileview-scroll")).scrollTo({
                            top: document.querySelector(".fileview-scroll").scrollHeight,
                            behavior: "smooth",
                        });
                    }, 500);
                })
                .catch((err) => {
                    this.newTeamValue = "";
                    // this.createTeamModal = false;
                    if (err == "teamNumLimit") {
                        (<any>this).$Modal.warning({
                            title: this.$t("createTeamFailed"),
                            content: this.$t("teamMax"),
                        });
                    } else if (err.data && err.data.msg === "ERR_ILLEGALWORD") {
                        (<any>this).$Modal.warning({
                            title: this.$t("tip"),
                            content: this.$t("sensitiveLimit"),
                        });
                    } else {
                        this.$edMessage.error({ content: this.$t("createTeamFailed") });
                    }
                });
        }
        reTeamName() {
            if (!this.selectItem || !this.selectItem.id) return;
            let teamId = this.selectItem.id;
            let teamName = this.editTeamName;
            if (!teamName) {
                (<any>this).$edMessage.warning(this.$t("noSpaceNameTip"));
                return;
            }
            if (teamName.length > 100) {
                this.newTeamValue = "";
                this.$edMessage.error(this.$t("spaceNameLimit"));
                return;
            }
            this.$store
                .dispatch("updateTeamInfo", { teamId, teamName })
                .then((res) => {
                    this.editTeamName = "";
                    this.$store.dispatch("getTeamList").then((res) => {
                        this.reTeamNameModal = false;
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    });
                })
                .catch((err) => {
                    console.log("err123", err);
                    this.editTeamName = "";
                    if (err.data && err.data.msg === "ERR_ILLEGALWORD") {
                        (<any>this).$Modal.warning({
                            title: this.$t("tip"),
                            content: this.$t("sensitiveLimit"),
                        });
                    } else {
                        this.$edMessage.error({ content: this.$t("createTeamFailed") });
                    }
                });
        }
        deleltTeam() {
            if (this.curTeamName !== this.selectItem.name) {
                this.$Message.warning(this.$t("notSameNameTip"));
                return;
            }
            this.curTeamName = "";
            this.delTeamModal = false;
            this.delTeamConfirmModal = true;
        }
        confirmDeleltTeam() {
            if (!this.selectItem || !this.selectItem.id) return;
            let teamId = this.selectItem.id;
            this.$store.dispatch("deleteTeam", teamId).then((res) => {
                this.delTeamConfirmModal = false;
                (<any>this).delTeamInput = "";
                this.$bus.$emit("confirmDeleteTeam");
                this.$bus.$emit("closeSetting");
                this.sensors.track("deleteSpace", {
                    Catalogues: "Team",
                });
            });
        }

        newTeamKeydown(e) {
            console.log("e", e);
            if (e.keyCode === 13) {
            }
        }

        cancelDelete() {
            this.delTeamModal = false;
            this.curTeamName = "";
        }

        deleteVisibleChange(val) {
            if (!val) {
                this.curTeamName = "";
            }
        }

        mounted() {
            this.$bus.$on("changeTeamName", (item) => {
                this.selectItem = item;
                this.showReTeamNameModal();
            });
            this.$bus.$on("deleteTeam", (item) => {
                this.selectItem = item;
                this.showDelTeamMdoal();
            });
        }
        beforeDestroy() {
            this.contextmenuBoxShow = false;
        }
    }
</script>

<style lang="stylus" scoped>
        .ivu-table-wrapper
            border unset
        /deep/.ivu-table
            &::before
                display none
            &::after
                display none
            table
                td,tr,th
                    border none !important
                th
                    font-size 12px
                    font-weight 400
                    color #222 !important
                    background unset
                .name-tag
                    display inline-block
                    color #fff
                    width 22px
                    height 22px
                    line-height 24px
                    text-align center
                    margin-right 8px
                    border-radius 4px
                    font-size 13px
        /deep/.ivu-table-row-hover
            background-color: rgba(242, 244, 249, 0.60) !important;


        /deep/.ivu-table-header
            border-bottom 1px solid rgba(0, 0, 0, 0.08)

        /deep/ .ivu-modal-body
            padding 8px 24px
            color #222

        .ed-fileview
            .fileview-list-header-teams
                span
                    font-size 14px
        .team-list
            height calc(100% - 52px)
            .breadCrumb
                display flex
                justify-content space-between
                width 100%
                .create-btn
                    display inline-flex
                    height 28px
                    padding 6px 16px 6px 12px
                    justify-content center
                    align-items center
                    border-radius 4px
                    border 1px solid #017FFF
                    color #017FFF
                    font-size 14px
                    font-weight 400
                    &:hover
                        opacity 0.8
                    span
                        margin-right 2px

            .team-box
                height calc(100% - 52px)
                margin-right 0px
                width 100%

                .no-team-box
                    align-items center
                    display flex
                    flex-direction column
                    margin-bottom 100px
                    font-size 12px
                    .no-teams-tip
                        color rgba(0, 0, 0, 0.50)
                        margin-top 8px
                    .create-desc
                        margin 16px 0 24px
                    .create-btn
                        padding 6px 16px
                        background #017FFF
                        border-radius 4px
                        color #fff
                        cursor pointer
                        &:hover
                           opacity 0.8
                .teams
                    height 100%
                    width 100%
            .flex-temp-box
                display flex
                justify-content center
                align-items center

        .footer-btns
            display flex
            justify-content flex-end
            bottom 24px
            right 24px
            padding-top 8px
            .btn
                width 72px
                height 28px
                text-align center
                line-height 28px
                border-radius 6px
                font-size 12px
                cursor pointer
                &:hover
                    opacity 0.8
            .ok-btn
                margin-right 16px
                background #017FFF
                color #fff
            .cancel-btn
                background #EBEDF1
                color #000
            .red-btn
                background #FF4040
    /deep/.ivu-modal-wrap
        .ivu-modal-footer
            padding 8px 24px 24px
    /deep/.ivu-input:focus
        box-shadow unset

    .close-icon
        margin-right 12px
        margin-top 12px
        cursor pointer
        &:hover
            opacity 0.6

    /deep/.ivu-input
        color #222
</style>

<i18n>
{
  "zh": {
    "myTeam": "团队",
    "teams": "团队空间",
    "createTeam": "新建群",
    "createTeamFailed": "创建空间失败（至少一个字符，不能包含特殊字符& % $ 等）",
    "teamMax": "群数量已达上限",
    "instruction": "使用说明",
    "teamNameLenError": "群名至少三个字符",
    "okText": "确定",
    "cancelText": "取消",
    "editTeamName": "编辑群名称",
    "createTeam": "创建团队空间",
    "noTeam":  "还没有团队空间",
    "createTip": "创建团队空间，与团队共享文件",
    "namePlaceholder": "请输入空间名称",
    "create": "创建",
    "cancel": "取消",
    "spaceName": "空间名称",
    "editSpaceName": "修改空间名称",
    "save": "保存",
    "owner": "创建者",
    "member": "空间成员",
    "updateTime": "创建时间",
    "newCreate": "新建",
    "rename": "重命名",
    "memberManage": "成员管理",
    "deleteSpace": "删除空间",
    "confirmSpaceName": "请在下方输入要解散的团队名称",
    "confirmDeletePlaceholder": "请输入当前空间名称确认删除",
    "delete": "删除",
    "tip": "提示",
    "deleteSpaceTip":"删除后空间将被解散，空间内所有文件将被删除且无法恢复",
    "spaceNameLimit": "团队名称最长100字",
    "sensitiveLimit": "提交信息中包含敏感词汇，请您更正！",
    "noSpaceNameTip": "请输入空间名称",
    "notSameNameTip": "输入名称与选中的团队名称不符"
  },
  "en": {
    "myTeam": "Teams",
    "createTeam": "New group",
    "createTeamFailed": "Create operation failed(At least one character, no special characters &% $ etc.)",
    "teamMax": "You have reached maximum number of groups.",
    "instruction": "User guide",
    "teamNameLenError": "Group name has at least three characters",
    "okText": "OK",
    "cancelText": "Cancel",
    "editTeamName": "Edit group name",
    "teams": "Teams",
    "createTeam": "Create team",
    "noTeam": "There's no team yet",
    "createTip": "Create team space to share files with your team",
    "namePlaceholder": "Please enter space name",
    "create": "Create",
    "cancel": "Cancel",
    "spaceName": "Space Name",
    "editSpaceName": "Edit Space Name",
    "save": "Save",
    "owner": "Owner",
    "member": "Member",
    "updateTime": "Update Time",
    "newCreate": "Create",
    "rename": "Rename",
    "memberManage": "Member Management",
    "deleteSpace": "Delete Space",
    "confirmSpaceName": "Please enter the name of the space you want to dissolve below",
    "confirmDeletePlaceholder": "Please enter the current name to confirm deletion",
    "delete": "Delete",
    "tip": "Message",
    "deleteSpaceTip": "Upon deletion, the space will be disbanded. All files within the space will be deleted and cannot be recovered",
    "spaceNameLimit": "The team name can be up to 100 characters long",
    "sensitiveLimit": "The submitted information contains sensitive words, please correct them",
    "noSpaceNameTip": "Please enter the space name",
    "notSameNameTip": "The entered name does not match the selected team name",
    "delete": "Delete"
  },
  "fr": {
    "myTeam": "équipes",
    "createTeam": "Nouveau groupe",
    "createTeamFailed": "Échec de la création d'un espace (au moins un caractère, les caractères spéciaux tels que & % $ ne sont pas autorisés)",
    "teamMax": "Le nombre de groupes a atteint la limite supérieure",
    "instruction": "Instructions d'utilisation",
    "teamNameLenError": "Le nom du groupe comporte au moins trois caractères",
    "okText": "Créer",
    "cancelText": "Annuler",
    "editTeamName": "Modifier le nom du groupe",
    "teams": "Équipes",

    "spaceName": "Nom de l'espace",
    "owner": "Propriétaire",
    "member": "Membre",
    "updateTime": "Mettre l'heure à jour",
    "createTeam": "Créer une équipe",
    "namePlaceholder": "Veuillez saisir un nom d'espace",
    "create": "Créer",
    "cancel": "Annuler",
    "noTeam": "Pas encore d'espace d'équipe",
    "createTip": "Créez un espace d'équipe pour partager des fichiers avec votre équipe.",
    "editSpaceName": "Modifier le nom de l'espace",
    "save": "Enregistrer",
    "deleteSpace": "Supprimer l'espace",
    "confirmSpaceName": "Veuillez saisir le nom de l'espace que vous souhaitez dissoudre ci-dessous",
    "confirmDeletePlaceholder": "Veuillez saisir le nom actuel pour confirmer la suppression",
    "delete": "Supprimer",
    "tip": "Mensaje",
    "deleteSpaceTip": "En cas de suppression, l'espace sera dissous. Tous les fichiers de l'espace seront supprimés et ne pourront pas être récupérés.",
    "spaceNameLimit": "Le nom de l'équipe ne peut pas dépasser 100 caractères.",
    "sensitiveLimit": "Les informations soumises contiennent des mots interdits, veuillez les corriger.",
    "notSameNameTip": "Le nom saisi ne correspond pas au nom de l'équipe sélectionnée.",
    "rename": "Renommer",
    "memberManage": "Gestion des membres"
  },
  "jp": {
    "myTeam": "チーム",
    "createTeam": "グループの新規作成",
    "createTeamFailed": "スペースの作成に失敗しました（&%$などの特殊文字を除く1文字以上で指定してください）",
    "teamMax": "グループ数が上限に達しました",
    "instruction": "使用ガイド",
    "teamNameLenError": "グループ名は3文字以上です",
    "okText": "確認",
    "cancelText": "キャンセル",
    "editTeamName": "グループ名を編集",
    "teams": "チーム",

    "spaceName": "スペース名",
    "owner": "所有者",
    "member": "メンバー",
    "updateTime": "更新日時",
    "createTeam": "チームを作成",
    "namePlaceholder": "スペース名を入力してください",
    "create": "作成",
    "cancel": "キャンセル",
    "noTeam": "チームスペースはまだありません",
    "createTip": "チームとファイルを共有するためのチームスペースを作成します。",
    "editSpaceName": "スペース名を編集",
    "save": "保存",
    "deleteSpace": "スペースを削除",
    "confirmSpaceName": "削除するスペースの名前を入力してください",
    "confirmDeletePlaceholder": "現在の名前を入力して削除を確認してください",
    "delete": "削除",
    "tip": "メッセージ",
    "deleteSpaceTip": "スペースを削除すると、スペース内のすべてのファイルが削除され、復元できなくなります。",
    "spaceNameLimit": "チーム名は100文字以内で指定してください。",
    "sensitiveLimit": "送信された情報には取り扱いに注意が必要な内容が含まれています。修正してください。",
    "notSameNameTip": "入力された名前が選択されたチーム名と一致しません。",
    "rename": "名前を変更する",
    "memberManage": "メンバー管理"
  },
  "de": {
    "myTeam": "Teams",
    "createTeam": "Neue Gruppe",
    "createTeamFailed": "Erstellung des Bereichs fehlgeschlagen (mindestens ein Zeichen, Sonderzeichen wie & % $ sind nicht zulässig)",
    "teamMax": "Sie haben die maximale Anzahl von Gruppen erreicht",
    "instruction": "Nutzeranleitung",
    "teamNameLenError": "Der Gruppenname besteht aus mindestens drei Zeichen",
    "okText": "Sichern",
    "cancelText": "Abbrechen",
    "editTeamName": "Gruppenname erstellen",
    "teams": "Teams",
    "spaceName": "Bereichsname",
    "owner": "Besitzer",
    "member": "Mitglied",
    "updateTime": "Zeit aktualisieren",
    "createTeam": "Team erstellen",
    "namePlaceholder": "Bitte geben Sie den Bereichsnamen ein",
    "create": "Erstellen",
    "cancel": "Abbrechen",
    "noTeam": "Noch kein Teambereich vorhanden",
    "createTip": "Créez un espace d'équipe pour partager des fichiers avec votre équipe.",
    "editSpaceName": "Bereichsname bearbeiten",
    "save": "Speichern",
    "deleteSpace": "Bereich löschen",
    "confirmSpaceName": "Bitte geben Sie unten den Namen des zu löschenden Bereichs ein",
    "confirmDeletePlaceholder": "Bitte geben Sie den aktuellen Namen ein, um den Löschvorgang zu bestätigen",
    "delete": "Löschen",
    "tip": "Nachricht",
    "deleteSpaceTip": "Nach dem Löschen ist der Bereich nicht mehr verfügbar. Alle Dateien innerhalb dieses Bereichs werden gelöscht und können nicht wiederhergestellt werden.",
    "spaceNameLimit": "Der Teamname darf maximal 100 Zeichen lang sein.",
    "sensitiveLimit": "Die übermittelten Informationen enthalten sensible Begriffe, bitte korrigieren Sie diese.",
    "notSameNameTip": "Der eingegebene Name stimmt nicht mit dem ausgewählten Teamnamen überein.",
    "rename": "Umbenennen",
    "memberManage": "Mitgliederverwaltung"
  },
  "es": {
    "myTeam": "equipos",
    "createTeam": "Nuevo grupo",
    "createTeamFailed": "Error al crear el espacio (al menos uno de los caracteres es un carácter especial, como &, % o $, los cuales no están permitidos).",
    "teamMax": "Has alcanzado el número máximo de grupos.",
    "instruction": "Guía del usuario",
    "teamNameLenError": "El nombre del grupo tiene al menos tres caracteres",
    "okText": "Confirmar",
    "cancelText": "Cancelar",
    "editTeamName": "Editar nombre del grupo",
    "teams": "equipos",

    "spaceName": "Nombre del espacio",
    "owner": "Propietario",
    "member": "Miembro",
    "updateTime": "Fecha de actualización",
    "createTeam": "Crear equipo",
    "namePlaceholder": "Introduce el nombre del espacio",
    "create": "Crear",
    "cancel": "Cancelar",
    "noTeam": "Aún no hay un espacio del equipo",
    "createTip": "Crea un espacio del equipo para compartir archivos con sus miembros.",
    "editSpaceName": "Editar nombre del espacio",
    "save": "Guardar",
    "deleteSpace": "Eliminar espacio",
    "confirmSpaceName": "A continuación, introduce el nombre del espacio que deseas disolver.",
    "confirmDeletePlaceholder": "Introduce el nombre actual para confirmar la eliminación",
    "delete": "Eliminar",
    "tip": "Mensaje",
    "deleteSpaceTip": "Tras eliminarlo, el espacio se disolverá. Todos los archivos se eliminarán y no se podrán recuperar.",
    "spaceNameLimit": "El nombre del equipo puede tener un máximo de 100 caracteres.",
    "sensitiveLimit": "La información enviada contiene palabras sensibles, corrígelas.",
    "notSameNameTip": "El nombre introducido no coincide con el nombre del equipo seleccionado.",
    "rename": "Renombrar",
    "memberManage": "Gestión de miembros"
  },
  "pt": {
    "myTeam": "times",
    "createTeam": "Novo grupo",
    "createTeamFailed": "Falha ao criar espaço (Pelo menos um caractere. Caracteres especiais, como &, % e $, não são permitidos)",
    "teamMax": "Atingiu o número máximo de grupos.",
    "instruction": "Guia de usuário",
    "teamNameLenError": "O nome do grupo tem pelo menos três caracteres",
    "okText": "OK",
    "cancelText": "Cancelar",
    "editTeamName": "Editar nome do grupo",
    "teams": "times",

    "spaceName": "Nome do espaço",
    "owner": "Proprietário",
    "member": "Membro",
    "updateTime": "Hora da atualização",
    "createTeam": "Criar equipe",
    "namePlaceholder": "Insira o nome do espaço",
    "create": "Criar",
    "cancel": "Cancelar",
    "noTeam": "Ainda não há espaço de equipe",
    "createTip": "Crie um espaço de equipe para compartilhar arquivos com a sua equipe.",
    "editSpaceName": "Editar o nome do espaço",
    "save": "Salvar",
    "deleteSpace": "Excluir espaço",
    "confirmSpaceName": "Insira abaixo o nome do espaço que você deseja desativar",
    "confirmDeletePlaceholder": "Insira o nome atual para confirmar a exclusão",
    "delete": "Excluir",
    "tip": "Mensagem",
    "deleteSpaceTip": "Após a exclusão, o espaço será desativado. Todos os arquivos que estiverem dentro do espaço serão excluídos e não poderão ser recuperados.",
    "spaceNameLimit": "O nome de equipe pode ter até 100 caracteres.",
    "sensitiveLimit": "As informações enviadas contêm palavras sensíveis. Corrija-as.",
    "notSameNameTip": "O nome inserido não corresponde ao nome de equipe selecionado.",
    "rename": "Renomear",
    "memberManage": "Gestão de membros"
  },
  "it": {
    "myTeam": "squadre",
    "createTeam": "Nuovo Team",
    "createTeamFailed": "Impossibile creare spazio (immetti almeno un carattere Non sono consentiti caratteri speciali come &, % e $)",
    "teamMax": "Hai raggiunto il numero massimo di Team.",
    "instruction": "Guida Utente",
    "teamNameLenError": "Il nome del gruppo ha almeno tre caratteri",
    "okText": "OK",
    "cancelText": "Annulla",
    "editTeamName": "Modifica Nome Team",
    "teams": "Squadre",

    "spaceName": "Nome spazio",
    "owner": "Proprietario",
    "member": "Membro",
    "updateTime": "Data di aggiornamento",
    "createTeam": "Crea team",
    "namePlaceholder": "Immetti un nome per lo spazio.",
    "create": "Crea",
    "cancel": "Annulla",
    "noTeam": "Spazio per il team non ancora creato",
    "createTip": "Crea uno spazio per condividere i file con il team.",
    "editSpaceName": "Modifica nome spazio",
    "save": "Salva",
    "deleteSpace": "Elimina spazio",
    "confirmSpaceName": "Immetti sotto il nome dello spazio che desideri disattivare",
    "confirmDeletePlaceholder": "Immetti il nome corrente per confermare l'eliminazione",
    "delete": "Elimina",
    "tip": "Messaggi",
    "deleteSpaceTip": "Dopo l'eliminazione, lo spazio verrà disattivato. Tutti i file contenuti verranno eliminati e non potranno essere recuperati.",
    "spaceNameLimit": "Il nome del team può contenere fino a 100 caratteri.",
    "sensitiveLimit": "Le informazioni inviate contengono parole offensivi. Correggi.",
    "notSameNameTip": "Il nome immesso non corrisponde al nome del team selezionato.",
    "rename": "Rinomina",
    "memberManage": "Gestione dei membri"
  },
  "tw": {
    "myTeam": "團隊",
    "createTeam": "新建群",
    "createTeamFailed": "無法建立空間 (至少一個字元，不能包含 & % $ 等特殊字元)",
    "teamMax": "群數量已達上限",
    "instruction": "使用說明",
    "teamNameLenError": "群名至少三個字符",
    "okText": "確定",
    "cancelText": "取消",
    "editTeamName": "編輯群名稱",
    "teams": "團隊",

    "spaceName": "空間名稱",
    "owner": "擁有者",
    "member": "成員",
    "updateTime": "更新時間",
    "createTeam": "建立團隊",
    "namePlaceholder": "請輸入空間名稱",
    "create": "建立",
    "cancel": "取消",
    "noTeam": "還沒有團隊空間",
    "createTip": "建立團隊空間，與您的團隊共用檔案。",
    "editSpaceName": "編輯空間名稱",
    "save": "儲存",
    "deleteSpace": "刪除空間",
    "confirmSpaceName": "請在下方輸入您想要解散的空間名稱",
    "confirmDeletePlaceholder": "請輸入目前的名稱以確認刪除",
    "delete": "刪除",
    "tip": "訊息",
    "deleteSpaceTip": "刪除後，空間將會解散。空間內的所有檔案將會刪除，且無法復原。",
    "spaceNameLimit": "團隊名稱長度最多可達 100 個字元。",
    "sensitiveLimit": "提交的資訊包含敏感字詞，請予以更正。",
    "notSameNameTip": "輸入的名稱與所選的團隊名稱不相符。",
    "rename": "重命名",
    "memberManage": "成员管理"
  },
  "kr": {
    "myTeam": "팀",
    "createTeam": "그룹 만들기",
    "createTeamFailed": "공간 생성 실패(문자 1자를 포함해야 하며 &, %, $ 등의 특수 문자는 허용되지 않습니다)",
    "teamMax": "그룹 수량이 최대치에 도달했습니다.",
    "instruction": "사용 가이드",
    "teamNameLenError": "그룹 이름은 3 자 이상이여야 합니다.",
    "okText": "확인",
    "cancelText": "취소",
    "editTeamName": "그룹 이름 편집",
    "teams": "팀",

    "spaceName": "공간 이름",
    "owner": "소유자",
    "member": "구성원",
    "updateTime": "업데이트 시간",
    "createTeam": "팀 만들기",
    "namePlaceholder": "공간 이름을 입력하세요.",
    "create": "만들기",
    "cancel": "취소",
    "noTeam": "아직 팀 공간 없음",
    "createTip": "팀과 파일을 공유할 팀 공간을 만드세요.",
    "editSpaceName": "공간 이름 편집",
    "save": "저장",
    "deleteSpace": "공간 삭제",
    "confirmSpaceName": "해체할 공간의 이름을 입력하세요.",
    "confirmDeletePlaceholder": "현재 이름을 입력해 삭제를 확인하세요.",
    "delete": "삭제",
    "tip": "메시지",
    "deleteSpaceTip": "삭제되면 공간이 해체됩니다. 공간 내의 모든 파일이 삭제되며 복구할 수 없습니다.",
    "spaceNameLimit": "팀 이름은 최대 100자까지 입력할 수 있습니다.",
    "sensitiveLimit": "제출된 정보에 민감한 단어가 포함되어 있으니 수정하세요.",
    "notSameNameTip": "입력한 이름이 선택한 팀 이름과 일치하지 않습니다.",
    "rename": "이름 바꾸기",
    "memberManage": "회원 관리"
  },
  "id": {
    "myTeam": "Tim",
    "createTeam": "Grup baru",
    "createTeamFailed": "Gagal membuat grup (minimal terdiri dari satu karakter, tidak ada karakter khusus &% $ dll.)",
    "teamMax": "Anda telah mencapai jumlah grup maksimum.",
    "instruction": "Panduan pengguna",
    "teamNameLenError": "Nama grup sedikitnya memiliki tiga karakter",
    "okText": "OKE",
    "cancelText": "Batalkan",
    "editTeamName": "Edit nama grup",
    "teams": "Tim"
  }
}
</i18n>
